import React, { FC } from 'react';
import { UIIcon } from '../../controls/ui/UIIcon/UIIcon';
import './BenefitsPanel.scss';

interface BenefitsPanelProps {
  splashImage: string;
  title: string;
}

const benefits = [
  'Get answers to all your work questions',
  'Find any doc, task, or message instantly',
  'Generate copy, summarize docs, debug code, and much more',
];

export const BenefitsPanel: FC<BenefitsPanelProps> = ({
  splashImage,
  title,
}) => {
  return (
    <div className="benefitsPanel">
      <div className="imgContainer">
        <img src={splashImage} />
      </div>
      <div className="benefitsText">
        <h3>{title}</h3>
        <ul>
          {benefits.map((benefit, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={i}>
              <UIIcon name="check-circle-filled" />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
